export { default } from './IntersectionObserver';
export { parseRootMargin } from './utils';
export * from './hook';



//////////////////
// WEBPACK FOOTER
// ../~/@researchgate/react-intersection-observer/lib/es/index.js
// module id = 1771
// module chunks = 121